import React, { useState } from 'react';
import axios from 'axios';
import progressGif from "../../images/progress.gif"; 


const monthsList = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

function Offline_Upload_Status() {
  const now = new Date();
  const [month, setMonth] = useState(now.getMonth() + 1); 
  const [year, setYear] = useState(now.getFullYear());   
  const [shopNo, setShopNo] = useState('');

  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState('');
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);

  const getYearOptions = () => {
    const current = now.getFullYear();
    const years = [];
    for (let i = -1; i < 2; i++) {
      years.push(current + i);
    }
    return years;
  };

const handleSubmit = async () => {
  const fpsIdToSend = shopNo.trim() !== '' ? shopNo.trim() : '0';
  console.log('Submitting:', { fpsId: fpsIdToSend, month, year });

  setLoading(true);
  setError('');
  setNoData(false);
  setTableData([]);

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_URL}/api/offlineStatus/offlineRecord`,
      {
        params: {
          fpsId: fpsIdToSend,
          month: month,
          year: year,
          t: Date.now(),
        },
        withCredentials: true,
      }
    );

    console.log('Raw response:', res.data);

    setTimeout(() => {
      if (!res.data || !Array.isArray(res.data) || res.data.length === 0) {
        setNoData(true);
        setTableData([]);
        window.alert('No data found for the given selection.');
      } else {
        const mappedData = res.data.map((rec) => ({
          distNameEn: rec.distNameEn ?? rec.dist_name_en ?? '',
          afsoNameEn: rec.afsoNameEn ?? rec.afso_name_en ?? '',
          fpsId: rec.fpsId ?? rec.fps_id ?? '',
          totalRecords: rec.totalRecords ?? rec.total_records ?? 0,
          updatedCount: rec.updatedCount ?? rec.updated_count ?? 0,
          variation: rec.variation ?? 0,
        }));
        setTableData(mappedData);
        window.alert('Data loaded successfully!');
      }
      setLoading(false); 
    }, 2000);

  } catch (err) {
    console.error('Error fetching data:', err);
    setTableData([]);
    setNoData(false);
    setLoading(false);

    if (err.response && err.response.status === 400) {
      setError('Invalid request.');
      window.alert('Invalid request.');
    } else {
      setError('Error fetching data');
      window.alert('Error fetching data from server.');
    }
  }
};


const goBack = () => {
  setShopNo('');
  setTableData([]);
  setError('');
  setNoData(false);
};

const totals = tableData.reduce(
  (acc, rec) => {
    acc.totalRecords +=rec.totalRecords || 0;
    acc.updatedCount +=rec.updatedCount || 0;
    acc.variation += rec.variation || 0;
    return acc;
  },
  {totalRecords: 0, updatedCount: 0, variation: 0}
);

  return (
    <div style={{ padding: '20px' }}>
      <table
  style={{
    width: '50%',
    margin: '0 auto',
    borderCollapse: 'collapse',
    border: '1px solid #ccc',
  }}
>
  <thead>
    <tr style={{ backgroundColor: 'black', color: 'white' }}>
      <th colSpan="4" style={{ padding: '8px', textAlign: 'center' }}>
        OFFLINE UPLOAD STATUS
      </th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td style={{ padding: '10px' }}>
        <label style={{ marginRight: '5px' }}>Month:</label>
        <select
          name="month"
          id="month"
          value={month}
          onChange={(e) => setMonth(parseInt(e.target.value, 10))}
        >
          {monthsList.map((m, idx) => (
            <option key={idx} value={idx + 1}>
              {m}
            </option>
          ))}
        </select>
      </td>
      <td style={{ padding: '10px' }}>
        <label style={{ marginRight: '5px' }}>Year:</label>
        <select
          id="year"
          name="year"
          value={year}
          onChange={(e) => setYear(parseInt(e.target.value, 10))}
        >
          {getYearOptions().map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </td>
      <td style={{ padding: '10px' }}>
        <label style={{ marginRight: '5px' }}>Shop No:</label>
        <input
          type="text"
          value={shopNo}
          onChange={(e) => setShopNo(e.target.value)}
          placeholder="Enter FPS ID"
        />
      </td>
    </tr>

    <tr>
      <td colSpan={3} align="center" style={{ padding: '10px' }}>
        <button
          onClick={handleSubmit}
          className="button button2"
          disabled={loading}
          style={{ marginRight: '10px' }}
        >
          Submit
        </button>
        <button className="button button2" onClick={goBack}>
          Back
        </button>
      </td>
    </tr>
  </tbody>
</table>

{error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}

{loading && (
  <div style={{ textAlign: "center", marginTop: "20px" }}>
    <img src={progressGif} alt="Loading..." width="250" height="15" />
  </div>
)}

{!loading && noData && (
  <p style={{ textAlign: 'center', color: 'red', marginTop: '20px', fontSize: '20px' }}>
    Details Not Found
  </p>
)}

{!loading && tableData.length > 0 && (
  <table
    style={{
      marginTop: '20px',
      width: '80%',
      marginLeft: 'auto',
      marginRight: 'auto',
      borderCollapse: 'collapse',
      border: '1px solid #ccc',
      marginBottom: '150px'
    }}
  >
    <thead>
      <tr style={{ backgroundColor: 'black', color: 'white' }}>
        <th style={{ border: '1px solid #ccc', padding: '5px'}}>Sl No</th>
        <th style={{ border: '1px solid #ccc', padding: '5px' }}>District</th>
        <th style={{ border: '1px solid #ccc', padding: '5px' }}>AFSO</th>
        <th style={{ border: '1px solid #ccc', padding: '5px' }}>FPS ID</th>
        <th style={{ border: '1px solid #ccc', padding: '5px' }}>TOTAL RECORDS</th>
        <th style={{ border: '1px solid #ccc', padding: '5px' }}>UPDATE COUNT</th>
        <th style={{ border: '1px solid #ccc', padding: '5px' }}>VARIATION</th>
      </tr>
    </thead>
    <tbody>
      {tableData.map((rec, idx) => (
        <tr key={idx}>
          <td style={{ border: '1px solid #ccc', padding: '5px'}}>{idx+1}</td>
          <td style={{ border: '1px solid #ccc', padding: '5px' }}>{rec.distNameEn}</td>
          <td style={{ border: '1px solid #ccc', padding: '5px' }}>{rec.afsoNameEn}</td>
          <td style={{ border: '1px solid #ccc', padding: '5px' }}>{rec.fpsId}</td>
          <td style={{ border: '1px solid #ccc', padding: '5px' }}>{rec.totalRecords}</td>
          <td style={{ border: '1px solid #ccc', padding: '5px' }}>{rec.updatedCount}</td>
          <td style={{ border: '1px solid #ccc', padding: '5px' }}>{rec.variation}</td>
        </tr>
      ))}

      <tr style={{ fontWeight: 'bold', backgroundColor: 'black', color: 'white'}}>
        <td style={{ border: '1px solid #ccc', padding: '5px'}} colSpan={4} align="center">
          TOTAL
        </td>
        <td style={{border: '1px solid #ccc', padding: '5px'}}>{totals.totalRecords}</td>
        <td style={{border: '1px solid #ccc', padding: '5px'}}>{totals.updatedCount}</td>
        <td style={{border: '1px solid #ccc', padding: '5px'}}>{totals.variation}</td>

      </tr>
    </tbody>
  </table>
)}

    </div>
  );
}

export default Offline_Upload_Status;
